import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useRealTimeSubscription } from '@core/providers/useRealTimeSubscription'
import { PusherOptions } from '@core/providers/usePusher'
import { siteBoxDocumentsKeys } from '../siteBoxDocumentsKeys'
import { foldersKeys } from '../../folders/foldersKeys'

export const useRealTimeSiteBoxConfiguration = (
  documentId: number,
  organisationId: number,
  projectId: number,
  options?: PusherOptions,
) => {
  const { channel, bindEventHandler } = useRealTimeSubscription(
    `private-document.${documentId}`,
    options,
  )
  const queryClient = useQueryClient()

  useEffect(() => {
    bindEventHandler('document.updated', (data) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys._def,
      })
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    })
  }, [channel, organisationId, projectId, documentId])
}
